import { useEffect, useState } from "react";

export const useRotateText = (textArray, delay) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex(index => (index + 1) % textArray.length);
    }, delay);

    return () => clearInterval(interval);
  }, []);

  return textArray[index];
};
